import '@app/components/RecordModal/components/RecordDetails/styles/PaymentButton.desktop.scss';

import { Button, Typography } from 'antd';

import type { FC } from 'react';

const { Text } = Typography;
const PF = 'payment-button';

export const PaymentButton: FC<{ onClick(): void }> = ({ onClick }) => (
  <div className={`${PF}__wrapper`} style={{ marginBottom: '20px' }}>
    <Button
      className={`${PF}__container`}
      onClick={onClick}
      data-testid="go-to-payment"
    >
      <div className="flex full-width flex-column jc-flex-start ai-flex-start">
        <Text className={`${PF}__title`}>Перейти к оплате</Text>
        <Text type="secondary">Детализация и способы оплаты</Text>
      </div>
    </Button>
  </div>
);
